import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="8" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.29.71a.996.996 0 000 1.41L5.17 6 1.29 9.88a.996.996 0 101.41 1.41L7.29 6.7a.996.996 0 000-1.41L2.7.7C2.32.32 1.68.32 1.29.71z" fill="#444" /></svg>;